// src/GenericStencil.tsx
import { isChromatic, useMotion } from "@brexhq/metal-utils";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { memo, useMemo } from "react";
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var StyledWrapper = styled.div(
  ({
    width,
    maxWidth,
    height,
    theme: { colors, borders },
    shade = "default"
  }) => [
    {
      display: "flex",
      width,
      height,
      backgroundColor: shade === "default" ? colors.stencil.default : colors.stencil.inverse.default,
      borderRadius: borders.radius.default,
      borderColor: colors.transparent
    },
    maxWidth && { maxWidth }
  ]
);
var GenericStencil = memo(
  ({ children, ...passThroughProps }) => {
    const {
      animations: {
        predefinedAnimations: { pulse }
      }
    } = useTheme();
    const durationInSeconds = useMemo(() => pulse.durationMs / 1e3, [pulse]);
    const { MotionWrapper, motion } = useMotion();
    const MotionStyledWrapper = React.useMemo(
      () => StyledWrapper.withComponent(motion.div),
      [motion]
    );
    return /* @__PURE__ */ jsx(MotionWrapper, {
      children: /* @__PURE__ */ jsx(MotionStyledWrapper, {
        ...passThroughProps,
        initial: { opacity: pulse.animatedFields.opacity.from },
        animate: isChromatic() ? false : { opacity: pulse.animatedFields.opacity.to },
        transition: {
          repeatType: "reverse",
          repeat: Infinity,
          duration: durationInSeconds
        },
        children
      })
    });
  }
);
export {
  GenericStencil
};
